<template>
  <div class="activityDetail">
    <div class="container">
      <div class="infoDetail">
        <div class="infoDetail_left">
          <img src="../../../src/assets/banner02.jpg" alt="">
        </div>
        <div class="infoDetail_right">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="24">
              <div class="titel">
                <h4>{{ detail.activityName }}</h4>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动日期：{{ detail.activityStartdate  }} - {{ detail.activityEnddate }}</p>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动时间：{{ detail.activityStarttime }} - {{ detail.activityEndtime }}</p>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动联系人：{{ detail.activityPeople }}</p>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>联系人电话：{{ detail.activityPhone }}</p>
              </div>
            </el-col>
             <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动地点：{{ detail.activityAddress }}</p>
              </div>
            </el-col>
             <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <div class="right_text">
                <p>活动简介：{{ detail.activityJianjie }}</p>
              </div>
            </el-col>
             <el-col :xs="24" :sm="24" :md="24">
              <div class="right_btn">
                <el-button @click="baoming">报名活动</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="activityContent">
        {{ detail.activityContent }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activityDetail',
  data () {
    return {
      detail: {}
    }
  },
  mounted () {
    let { id } = this.$route.query
    this.getactivityDetail(id)
  },
  methods: {
    async getactivityDetail(id) {
      let { data: { data, code  }} = await this.$http.get('activity/volunteeractivity/selectDetailById/' + id)
      console.log(data);
      if(code != 0) return
      console.table(data)
      this.detail = data
    },
    async baoming() {
      let { id: userId, realName } = JSON.parse(localStorage.getItem('userinfo'))
      let { id: activityId, activityName } = this.detail
      let dataform = { userId, activityName, activityId, realName }
      let { data: { code }} = await this.$http.post('/apply/apply', dataform)
      if (code != 0) return this.$message.warning("报名失败！");
      if (code == 500) return this.$message.warning("当前活动已报名,请勿重新报名！");
      this.$message.success("报名成功！");
    }
  }
}
</script>

<style lang="scss">
.activityDetail {
  padding: 30px 0;
  .infoDetail {
    background-color: #f4f4f5;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    justify-content: center;
    .infoDetail_left {
      flex: 1;
      padding-right: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .infoDetail_right {
      flex: 3;
      .titel {
        h4 {
          font-size: 22px;
          font-weight: 500;
          line-height: 1.5;
        }
        padding-bottom: 10px;
      }
      .right_text p{
        font-size: 14px;
        line-height: 1.5;
      }
      .right_btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-button {
          background-color: #be9c59;
          color: #fff;
        }
      }
    }
  }
  .activityContent {
    padding: 30px;
  }
}
</style>